

export const SIGNUP_SUCCESS = "signup/success" ;
export const LOGOUT = "logout" ;